// Skeleton
export const Skeleton = {
  baseStyle: () => {
    return {
      startColor: 'gray.50',
      _dark: {
        startColor: 'gray.50',
      },
      endColor: 'transparent',
      overflow: 'hidden',
      fadeDuration: 0.1,
      speed: 1.0,
      h: '24',
      w: '100%',
      rounded: 'md',
    };
  },
};

// SkeletonText
export const SkeletonText = {
  baseStyle: () => {
    return {
      startColor: 'gray.50',
      _dark: {
        startColor: 'gray.50',
      },
      endColor: 'transparent',
      fadeDuration: 0.1,
      w: '100%',
      speed: 1.0,
      flexDirection: 'column',
      _line: {
        h: 5,
        rounded: 'md',
      },
    };
  },
  defaultProps: {
    lines: 3,
    space: 2,
  },
};
